export const common = {
  nav: {
    home: 'Home',
    about: 'About',
    structure: 'Structure',
    contact: 'Contact'
  },
  footer: {
    legal: 'Legal',
    imprint: 'Imprint',
    privacy: 'Privacy Policy',
    cookieSettings: 'Cookie Settings',
    contact: 'Contact',
    copyright: '© 2026 DR Group GmbH. All rights reserved.',
    registerCourt: 'Register Court',
    hrb: 'HRB',
    vatId: 'VAT ID'
  },
  contact: {
    email: 'Email',
    address: 'Postal Address',
    phone: 'Phone'
  },
  cookies: {
    title: 'Cookie Settings',
    description: 'We use necessary cookies to operate this website securely. We set optional cookies only with your consent. See Cookie Settings and the Privacy Policy for details.',
    acceptAll: 'Accept all',
    rejectAll: 'Reject all',
    settings: 'Settings',
    settingsTitle: 'Cookie Settings',
    settingsIntro: 'Here you can manage your cookie preferences. Necessary cookies are always active as they are required for the website to function.',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'These cookies are required for the secure operation of the website and cannot be disabled.',
    functional: 'Functional Cookies',
    functionalDesc: 'These cookies enable enhanced functionality and personalization.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'These cookies help us understand how visitors interact with the website.',
    marketing: 'Marketing Cookies',
    marketingDesc: 'These cookies are used to show visitors relevant advertising.'
  }
};